/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbPlanAgrementDto
 */
export interface FcbPlanAgrementDto {
    /**
     * 
     * @type {number}
     * @memberof FcbPlanAgrementDto
     */
    idPlanAgrement?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbPlanAgrementDto
     */
    idCentre?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbPlanAgrementDto
     */
    anneeAcademique?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbPlanAgrementDto
     */
    dateValidation?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FcbPlanAgrementDto
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbPlanAgrementDto
     */
    remarque?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbPlanAgrementDto
     */
    idStatut?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbPlanAgrementDto
     */
    bloque?: boolean | null;
}

/**
 * Check if a given object implements the FcbPlanAgrementDto interface.
 */
export function instanceOfFcbPlanAgrementDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbPlanAgrementDtoFromJSON(json: any): FcbPlanAgrementDto {
    return FcbPlanAgrementDtoFromJSONTyped(json, false);
}

export function FcbPlanAgrementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbPlanAgrementDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idPlanAgrement': !exists(json, 'idPlanAgrement') ? undefined : json['idPlanAgrement'],
        'idCentre': !exists(json, 'idCentre') ? undefined : json['idCentre'],
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : json['anneeAcademique'],
        'dateValidation': !exists(json, 'dateValidation') ? undefined : (json['dateValidation'] === null ? null : new Date(json['dateValidation'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'idStatut': !exists(json, 'idStatut') ? undefined : json['idStatut'],
        'bloque': !exists(json, 'bloque') ? undefined : json['bloque'],
    };
}

export function FcbPlanAgrementDtoToJSON(value?: FcbPlanAgrementDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idPlanAgrement': value.idPlanAgrement,
        'idCentre': value.idCentre,
        'anneeAcademique': value.anneeAcademique,
        'dateValidation': value.dateValidation === undefined ? undefined : (value.dateValidation === null ? null : value.dateValidation.toISOString()),
        'url': value.url,
        'remarque': value.remarque,
        'idStatut': value.idStatut,
        'bloque': value.bloque,
    };
}

